<template>
    <contacts-find
        :params="{
            contact: $route.params.contact
        }"
        :include="[
            'address',
            'telephone_number'
        ]"
        v-slot="{
            data: contact,
            error: find_error,
            has_loaded: has_find_loaded,
            find
        }"
    >
        <div v-if="!has_find_loaded || find_error">
            <base-loading
                :error="find_error"
                :retry="find"
                class="py-6"
            />

            <error-modal
                v-if="find_error"
                :error="find_error"
            />
        </div>

        <contacts-update
            v-else
            :params="{
                contact: contact.uuid
            }"
            v-slot="{
                sid,
                is_loading: is_update_loading,
                has_loaded: has_update_loaded,
                error: update_error,
                update
            }"
            @success="onContactsUpdateSuccess"
        >
            <contacts-edit-or-create-form
                :contact="contact"
                :sid="sid"
                :is-loading="is_update_loading"
                :has-loaded="has_update_loaded"
                @submit="update"
            >
                <template v-slot:modals>
                    <error-modal
                        v-if="update_error && $error.is(update_error, { exclude: [422] })"
                        :error="update_error"
                    />

                    <modal-success
                        :is-open="show_updated_modal"
                    >
                        <template slot="heading">Contact edited!</template>

                        <p>
                            Your contact has been edited.
                        </p>

                        <div
                            slot="footer"
                            class="flex flex-col md:flex-row-reverse"
                        >
                            <router-link
                                :to="{
                                    name: $router.fix('dashboard.*.contacts.show'),
                                    params: {
                                        contact: contact.uuid
                                    }
                                }"
                                class="text-center btn btn-green"
                            >
                                Go to Contact
                            </router-link>
                        </div>
                    </modal-success>
                </template>
            </contacts-edit-or-create-form>
        </contacts-update>
    </contacts-find>
</template>

<script>
    import ContactsEditOrCreateForm from '../../../../components/contacts-edit-or-create-form'
    import ContactsFind from '../../../../components/contacts-find'
    import ContactsUpdate from '../../../../components/contacts-update'

    export default {
        components: {
            ContactsEditOrCreateForm,
            ContactsFind,
            ContactsUpdate
        },
        data () {
            return {
                show_updated_modal: false
            }
        },
        methods: {
            onContactsUpdateSuccess () {
                this.$track(
                    'dashboard.landlords.contacts.edit',
                    'form-submission',
                    'A landlord has edited a contact'
                )

                setTimeout(() => {
                    this.show_updated_modal = true
                }, 0)
            }
        }
    }
</script>
